import { render, staticRenderFns } from "./Fy.vue?vue&type=template&id=082e2ea8"
import script from "./Fy.vue?vue&type=script&lang=js"
export * from "./Fy.vue?vue&type=script&lang=js"
import style0 from "./Fy.vue?vue&type=style&index=0&id=082e2ea8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports